export default __webpack_public_path__ + "static/media/starryNight.e5726908.png";